<template>
  <!--
      作者：gmshop
      时间：2019-10-25
      描述：订单列表
  -->
  <div class="user">
    <!--搜索表单-->
    <div class="common-seach-wrap">
      <el-form size="small" :inline="true" :model="searchForm" class="demo-form-inline">
        <el-form-item label="订单号"><el-input size="small" v-model="searchForm.order_no" placeholder="请输入订单号"></el-input></el-form-item>
        <el-form-item label="买家ID">
          <el-input size="small" style="width:100px" v-model="searchForm.user_id" placeholder="买家ID"></el-input>
        </el-form-item>
         <el-form-item label="供货商ID">
          <el-input size="small" style="width:100px" v-model="searchForm.supplier_id" placeholder="供货商ID"></el-input>
        </el-form-item>
        <el-form-item label="起始时间">
          <div class="block">
            <span class="demonstration"></span>
            <el-date-picker
              size="small"
              v-model="searchForm.create_time"
              type="daterange"
              value-format="yyyy-MM-dd"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
            ></el-date-picker>
          </div>
        </el-form-item>
        <el-form-item><el-button size="small" type="primary" icon="el-icon-search" @click="onSubmit">查询</el-button></el-form-item>
        <el-form-item><el-button size="small" type="success" @click="onExport">导出</el-button></el-form-item>

      </el-form>
    </div>
    <!--内容-->
    <div class="product-content">
      <div class="table-wrap order-table-wrap">
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane label="全部订单" name="all"></el-tab-pane>
          <el-tab-pane label="未付款" name="payment"></el-tab-pane>
          <el-tab-pane label="待发货" name="delivery"></el-tab-pane>
          <el-tab-pane label="待收货" name="received"></el-tab-pane>
          <el-tab-pane label="待评价" name="comment"></el-tab-pane>
          <el-tab-pane label="已完成" name="six"></el-tab-pane>
        </el-tabs>
        <template>
          <div class="table-wrap">
            <el-row>
              <el-col :span="5">
                <div class="pb16">
                  <span class="c_main">订单金额：</span>
                  {{ order_statistics }} 元
                </div>
              </el-col>
            </el-row>
          </div>
        </template>
        <el-table size="small" :data="tableData" border style="width: 100%" >
          <el-table-column prop="order_no" label="订单信息" width="400">
            <template slot-scope="scope">
              <div class="order-code" >

                  <span class="state-text" :class="{'state-text-red':scope.row.orderM.order_source != 10}">{{scope.row.orderM.order_source_text}}</span>
                <span class="c_main">订单号：{{ scope.row.orderM.order_no }}</span>
              </div>
              <template>
                <div class="product-info">
                  <div class="pic"><img v-img-url="scope.row.image.file_path" alt="" /></div>
                  <div class="info">
                    <div class="name gray3 product-name">
                      <span>{{ scope.row.product_name }}</span>
                    </div>
                    <div class="gray9" v-if="scope.row.product_attr">{{ scope.row.product_attr }}</div>
                  </div>
                  <div class="d-c-c d-c">
                    <div class="orange">￥ {{ scope.row.product_price }}</div>
                  </div>
                </div>
              </template>
            </template>
          </el-table-column>
          <el-table-column prop="company_name" label="供货商">
              <template slot-scope="scope" >
              {{ scope.row.supplier.company_name }}
              (ID:{{ scope.row.supplier_id }})
            </template>
          </el-table-column>
          <el-table-column prop="total_num" label="数量"></el-table-column>
          <el-table-column prop="total_pay_price" label="实付款"></el-table-column>
          <el-table-column prop="" label="奖励">
            <template slot-scope="scope" v-if="!scope.row.is_top_row">
              <div class="c_main" v-if="scope.row.first_money">一级奖励：{{ scope.row.first_money }}</div>
              <div class="c_main" v-if="scope.row.second_money">二级奖励：{{ scope.row.second_money }}</div>
              <div class="c_main" v-if="scope.row.third_money">三级奖励：{{ scope.row.third_money }}</div>
            </template>
          </el-table-column>
          <el-table-column prop="" label="平台抽佣">
            <template slot-scope="scope" v-if="!scope.row.is_top_row">
              <div class="orange">抽佣比例：{{ scope.row.platform_commission }}%</div>
              <div class="c_main">抽佣金额：{{ scope.row.platform_commission_money }}元</div>
            </template>
          </el-table-column>
          <el-table-column prop="real_money" label="实际打款金额"></el-table-column>
          <el-table-column prop="state_text" label="交易状态">
            <template slot-scope="scope" >
              {{ scope.row.orderM.state_text }}
               <div class="orange" v-if="scope.row.refund">{{ scope.row.refund.type.text }}-{{ scope.row.refund.status.text }}</div>
            </template>

          </el-table-column>
          <el-table-column prop="pay_type.text" label="支付方式">
            <template slot-scope="scope" >
              <span class="gray9">{{ scope.row.orderM.pay_type.text }}</span>
            </template>
          </el-table-column>
          <el-table-column  label="下单时间">
            <template slot-scope="scope" >
              <span class="gray9">{{ scope.row.orderM.create_time }}</span>
            </template>
          </el-table-column>

        </el-table>
      </div>

      <!--分页-->
      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          background
          :current-page="curPage"
          :page-sizes="[20, 50, 100, 200, 300, 500]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalDataNumber"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import SupplierApi from '@/api/supplier.js';
import qs from 'qs';
export default {
  components: {

  },
  data() {
    return {
      /*是否打开添加弹窗*/
      open_add: false,
      /*切换菜单*/
      activeName: 'all',
      /*是否加载完成*/
      loading: true,
      /*列表数据*/
      tableData: [],
      /*一页多少条*/
      pageSize: 20,
      /*一共多少条数据*/
      totalDataNumber: 0,
      /*当前是第几页*/
      curPage: 1,
      /*横向表单数据模型*/
      searchForm: {
        user_id: "",
        order_no: "",
        supplier_id:'',
        create_time: ''
      },
      /*配送方式*/
      exStyle: [],
      /*门店列表*/
      shopList: [],
      /*时间*/
      create_time: '',
      /*统计*/
      order_count: {
        payment: 0,
        delivery: 0,
        received: 0
      },
      order_statistics: 0,
    };
  },
  created() {
    /*获取列表*/
    this.getData();
  },
  methods: {
    /*跨多列*/
    // arraySpanMethod(row) {
    //   if (row.rowIndex % 2 == 0) {
    //     if (row.columnIndex === 0) {
    //       return [1, 8];
    //     }
    //   }
    // },
    /*选择第几页*/
    handleCurrentChange(val) {
      let self = this;
      self.curPage = val;
      self.getData();
    },

    /*每页多少条*/
    handleSizeChange(val) {
      this.curPage = 1;
      this.pageSize = val;
      this.getData();
    },

    /*切换菜单*/
    handleClick(tab, event) {
      let self = this;
      self.curPage = 1;
      self.getData();
    },

    /*获取列表*/
    getData() {
      let self = this;
      let Params = this.searchForm;
      Params.dataType = self.activeName;
      Params.page = self.curPage;
      Params.list_rows = self.pageSize;
      self.loading = true;
      SupplierApi.orderlist(Params, true)
        .then(res => {
          self.tableData = res.data.list.data;
          self.order_statistics = res.data.order_statistics;
          self.totalDataNumber = res.data.list.total;
          self.order_count = res.data.order_count.order_count;
          self.loading = false;
        })
        .catch(error => {});
    },

    /*搜索查询*/
    onSubmit() {
      this.curPage = 1;
      this.tableData = [];
      this.getData();
    },


    onExport: function() {
      let baseUrl = window.location.protocol + '//' + window.location.host;
      window.location.href = baseUrl + '/index.php/shop/supplier.supplier/export?' + qs.stringify(this.searchForm);
    },
    /*关闭弹窗*/
    closeDialogFunc(e, f) {
      if (f == 'add') {
        this.open_add = e.openDialog;
        if (e.type == 'success') {
          this.getData();
        }
      }
      if (f == 'edit') {
        this.open_edit = e.openDialog;
        if (e.type == 'success') {
          this.getData();
        }
      }
    },
  }
};
</script>
<style lang="scss">
.product-info {
  padding: 10px 0;
  border-top: 1px solid #eeeeee;
}
.order-code .state-text {
  padding: 2px 4px;
  border-radius: 4px;
  background: #808080;
  color: #ffffff;
}
.order-code .state-text-red{ background: red;}
.table-wrap .product-info:first-of-type {
  border-top: none;
}
.order-table-wrap .el-table__body tbody .el-table__row:nth-child(odd) {
  background: #f5f7fa;
}
</style>



// WEBPACK FOOTER //
// src/views/supplier/supplier/order.vue